import { useState, useEffect } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import {
  Sun,
  Moon,
  Home,
  BookOpen,
  FlaskConical,
  Boxes,
  LogOut,
  User,
} from "lucide-react";
import "./Navbar.css";
// import "./logo1.png";

export default function Navbar() {
  const [theme, setTheme] = useState(localStorage.getItem("theme") || "dark");
  const [user, setUser] = useState({ comp_name: "", emp_id: "", department: "" });
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    document.body.setAttribute("data-theme", theme);
    localStorage.setItem("theme", theme);
  }, [theme]);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      const payload = JSON.parse(atob(token.split(".")[1]));
      setUser({
        comp_name: payload.comp_name || "User",
        emp_id: payload.emp_code || "E001",
        department: payload.department || "General",
      });
    }
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("token");
    navigate("/login");
  };

  // ✅ Click toggle for dropdown
  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <nav className="navbar">
      {/* LEFT SECTION */}
      <div className="nav-left">
        <div className="logo" onClick={toggleMenu}>
          ☰LogBooks
        </div>

        {/* Dropdown menu (on click toggle) */}
        {menuOpen && (
          <div className="nav-dropdown" onMouseLeave={() => setMenuOpen(false)}>
            <NavLink to="/dashboard" className="dropdown-item" onClick={() => setMenuOpen(false)}>
              <Home size={16} /> Dashboard
            </NavLink>
            <NavLink to="/logbooks" className="dropdown-item" onClick={() => setMenuOpen(false)}>
              <BookOpen size={16} /> Logbooks
            </NavLink>
            <NavLink to="/hematology-logs" className="dropdown-item" onClick={() => setMenuOpen(false)}>
              <FlaskConical size={16} /> Hematology
            </NavLink>
            <NavLink to="/reagent-inventory-logs" className="dropdown-item" onClick={() => setMenuOpen(false)}>
              <Boxes size={16} /> Reagents
            </NavLink>
          </div>
        )}
      </div>

      {/* CENTER SECTION */}
      <div className="nav-center" onClick={() => navigate("/dashboard")}>
        <img src="./logo1.png" alt="Org Logo" className="org-logo" />
      </div>

      {/* RIGHT SECTION */}
      <div className="nav-right">
        <button
          className="theme-toggle"
          onClick={() => setTheme(theme === "dark" ? "light" : "dark")}
        >
          {theme === "dark" ? <Sun size={18} /> : <Moon size={18} />}
        </button>

        <div className="user-section">
          <button className="avatar-btn" onClick={() => setDropdownOpen(!dropdownOpen)}>
            <User size={20} />
          </button>

          {dropdownOpen && (
            <div className="dropdown-menu">
              <p>{user.comp_name}</p>
              <p>{user.emp_id}</p>
              <p>{user.department}</p>
              <hr />
              <button onClick={handleLogout}>
                <LogOut size={16} /> Logout
              </button>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
}